var items = [];
var filteredItems = [];
var itemsContainer = [];
var continent = "allContinents";
var previousSearchString = "";

export function getCountryMenuWrapper(data, callback) {
    console.log("getCountryMenuWrapper called with data:", data);
    const payload = {};
    if (data.AreaId != null) payload.AreaId = data.AreaId;
    if (data.CourseTypeCountryId != null) payload.CourseTypeCountryId = data.CourseTypeCountryId;
    if (data.SpecialityId != null) payload.SpecialityId = data.SpecialityId;
    if (data.CourseCode != null) payload.CourseCode = data.CourseCode;

    $.ajax({
        type: "GET",
        url: tech.core.getInternationalUrl('/Home/GetCountryMenuWrapper/' + window.location.pathname.replace(/\//g, '|')),
        data: payload,
        dataType: "html",
        success: successFunc,
        error: errorFunc
    });

    function successFunc(data, status) {
        $("#faculties-menu-desktop-wrapper #tech-navigation").append(data);

        if(typeof callback !== "undefined") {
            callback();
        }
    }

    function errorFunc(jQXHR, textStatus, errorThrown) {
        console.log("An error occurred while trying to contact the server: " + jQXHR.status + " " + textStatus + " " + errorThrown);
    }
}

export function toggleSearch() {
    var searchMenu = document.getElementById("countriesSearch");
    searchMenu.classList.toggle('open');
    if (items.length === 0) {
        init();
    }
}
export function closeMenu() {
    document.getElementById("countriesSearch").classList.remove('open');
    console.log(document.body.clientWidth, $('.right-menu'));
    if (document.body.clientWidth > 768) {
        $('.page-content').click();
    } else {
        $('.right-menu').removeClass('open');
        $('.app-menu-header > .navbar').removeClass('white-bg')
        $('.page-content').click();
    }
}

function init() {
    itemsContainer = document.getElementById('searchItemsContainer');
    items = Array.from(document.getElementsByClassName('country-search-item'));
    filteredItems = items;
    continent = "allContinents";
    render(filteredItems);
}

function render(inItems) {
    itemsContainer.innerHTML = '';
    for(let i = 0; i < inItems.length; i++) {
        if (continent !== "allContinents") {
            let continentCode = inItems[i].firstChild.nextSibling.dataset.continentcode;
            console.log("ContinentCode:", continentCode, "Item:", inItems[i]);
            if (continent == continentCode) {
                itemsContainer.append(inItems[i])
            }
        } else {
            itemsContainer.append(inItems[i]);
        }
    }
}

export function search(searchString) {
    var matcher = new RegExp(searchString.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
    filteredItems = []
    for (let i = 0; i < items.length; i++) {
        let textContinent = items[i].firstChild.nextSibling.dataset.continentcode;
        let text = items[i].firstChild.nextSibling.children[1].outerText.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        var comparacion = text.substring(0, searchString.length);
        if (comparacion.search(matcher) != -1) {
            if (continent ===  "allContinents" || textContinent === continent) {
                filteredItems.push(items[i]);
            }
        }
    }
    render(filteredItems);
}

export function continentChange(element) {
    continent = element.value;
    search("");
}